import { isChartTemplate } from "../components/Card/guards.js";
const CELL_HEIGHT = 2.5;
const rows = (rows2) => rows2 * CELL_HEIGHT;
const VARIANTS = {
  CUSTOM: "custom",
  GRAPH_GAUGE: "graph-gauge",
  GRAPH_NARROW: "graph-narrow",
  GRAPH_WIDE: "graph-wide",
  GRAPH_FULL: "graph-full",
  TABLE: "table",
  TABLE_FULL: "table-full",
  TABLE_12: "table-12",
  TABLE_BIG: "table-big",
  TABLE_HALF: "table-half",
  TABLE_6: "table-6",
  VALUE_SINGLE: "value-single",
  BANNER: "banner",
  TEXT_BLOCK: "text-block",
  BAR_TREND: "funnel"
};
const CARD_DIMENSIONS_BY_VARIANTS = {
  [VARIANTS.CUSTOM]: {
    width: 3,
    minHeight: 3
  },
  [VARIANTS.GRAPH_GAUGE]: {
    width: 4,
    minHeight: 6
  },
  [VARIANTS.GRAPH_NARROW]: {
    width: 3,
    minHeight: 6
  },
  [VARIANTS.GRAPH_WIDE]: {
    width: 6,
    minHeight: 8
  },
  [VARIANTS.GRAPH_FULL]: {
    width: 12,
    minHeight: 10
  },
  [VARIANTS.TABLE_BIG]: {
    width: 12,
    minHeight: 12
  },
  [VARIANTS.TABLE_FULL]: {
    width: 12,
    minHeight: 12
  },
  [VARIANTS.TABLE]: {
    width: 12,
    minHeight: 12
  },
  [VARIANTS.TABLE_12]: {
    width: 12,
    minHeight: 12
  },
  [VARIANTS.TABLE_HALF]: {
    width: 6,
    minHeight: 12
  },
  [VARIANTS.TABLE_6]: {
    width: 6,
    minHeight: 12
  },
  [VARIANTS.VALUE_SINGLE]: {
    width: 3,
    minHeight: 2
  },
  [VARIANTS.BANNER]: {
    width: 12,
    minHeight: 2
  },
  [VARIANTS.TEXT_BLOCK]: {
    width: 12,
    minHeight: 2
  },
  [VARIANTS.BAR_TREND]: {
    width: 12,
    minHeight: 4
  }
};
const useCardSizes = () => ({
  getCardDimensions
});
const getCardDimensions = (variant = VARIANTS.CUSTOM, item, autoWidth) => {
  const {
    width,
    minHeight
  } = CARD_DIMENSIONS_BY_VARIANTS[variant] || CARD_DIMENSIONS_BY_VARIANTS[VARIANTS.CUSTOM];
  const isGauge = isChartTemplate(item) && item.slots.chart && item.slots.chart.type === "semi-circle";
  const cardWidth = item?.width ?? Math.max(autoWidth ?? 0, width);
  const cardHeight = isGauge ? void 0 : item?.height !== void 0 ? item.height : minHeight;
  const minHeightInRem = isGauge ? void 0 : typeof cardHeight === "number" && cardHeight > 0 ? `${rows(cardHeight)}rem` : "0rem";
  return {
    variant,
    width: cardWidth,
    minHeight: cardHeight,
    minHeightInRem
  };
};
export {
  useCardSizes as default,
  useCardSizes
};
